import React from "react";
import { useSelector } from "react-redux";
import {
  Card,
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import trackEvent from "bundles/common/utils/trackEvent";

const CreditsBox = () => {
  const i18nLocale = useSelector((state) => state.i18nLocale);
  const currentRecruiter = useSelector((state) => state.current_recruiter);

  const jobOfferCredits = currentRecruiter.job_offer_credits || [];

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();

  const useStyles = makeStyles(() => ({
    companyCardBox: {
      backgroundColor: "#FFF",
      borderRadius: "12px",
      boxShadow: "none",
      padding: "20px",
      flex: 1,
    },
    companyButton: {
      height: "35px",
      textTransform: "none",
      padding: "6px 24px !important",
      fontSize: "14px !important",
      backgroundColor: `${theme.palette.text.main} !important`,
      color: `${theme.palette.secondary.grey} !important`,
      fontWeight: "700 !important",
      fontFamily: "Segoe UI Bold, sans-serif",
      "&:hover": {
        backgroundColor: `${theme.palette.secondary.hover} !important`,
        color: `${theme.palette.text.main} !important`,
      },
    },
    creditsLabel: {
      fontWeight: 600,
      fontSize: "14px !important",
      color: theme.palette.text.main,
      fontFamily: "Segoe UI Semibold, sans-serif",
    },
    creditsContainer: {
      display: "flex", 
      justifyContent: "space-between", 
      alignItems: "center",
      marginTop: "8px",
    },
    creditsValue: {
      transform: "translateX(-6px)",
      color: "#000 !important",
      fontWeight: "600 !important",
      fontSize: "14px !important",
      fontFamily: "Segoe UI Semibold, sans-serif",
    },
  }));

  const classes = useStyles();

  return (
    <Card className={classes.companyCardBox}>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h3" sx={{ fontWeight: 600, fontSize: "20px !important", color: theme.palette.text.main, fontFamily: "Segoe UI Semibold, sans-serif" }}>
            <FormattedMessage id="credits_box.credits" />
          </Typography>
          {isDesktop ? (
            <Button variant="rounded" onClick={() => { trackEvent("billing", "buy_credits_clicked"); navigate(`/${i18nLocale}/recruiter/pricing`); }} className={classes.companyButton}>
              <FormattedMessage id="credits_box.renew" />
            </Button>
          ) : (
            <Button variant="rounded" onClick={() => navigate(`/${i18nLocale}/recruiter/job_offer_creation`)} className={classes.companyButton}>
              <FormattedMessage id="landing_recruiter.new_offer" />
            </Button>
          )}

        </Box>
        <Box className={classes.creditsContainer} sx={{ mt: "20px !important" }}>
          <Typography variant={isDesktop ? "h5" : "h4"} className={classes.creditsLabel}>
            <FormattedMessage id="credits_box.title" />
          </Typography>
                
          <Box
            sx={{
              background: "#E6FF00",
              borderRadius: "8px",
              padding: "4px 8px",
              display: "inline-block",
              fontWeight: 700,
              fontFamily: "Segoe UI Bold, sans-serif",
              color: "#234545",
              fontSize: "1rem",
              textAlign: "center",
              minWidth: "32px",
            }}
            className={classes.creditsValue}
          >
            {jobOfferCredits.length || 0}
          </Box>
        </Box>
        <Box className={classes.creditsContainer}>
          <Typography variant={isDesktop ? "h5" : "h4"} sx={{ fontWeight: 600 }} className={classes.creditsLabel}>
            <FormattedMessage id="credits_box.cv_access" />
          </Typography>
          {currentRecruiter?.resume_library_access ? (
            <Box
              sx={{
                background: "#E6FF00",
                borderRadius: "8px",
                padding: "4px 8px",
                display: "inline-block",
                color: "#234545",
                textAlign: "center",
                minWidth: "48px",
              }}
              className={classes.creditsValue}
            >
              <FormattedMessage id="recruiter.cv_access" />
            </Box>
          ) : (
            <Box
              sx={{
                background: "#E6FF00",
                borderRadius: "8px",
                px: 1.5,
                py: 0.5,
                display: "inline-block",
                fontWeight: "700 !important",
                fontFamily: "Segoe UI Bold, sans-serif",
                color: "#234545",
                fontSize: "14px !important",
                textAlign: "center",
                minWidth: "48px",
              }}
              className={classes.creditsValue}
            >
              <FormattedMessage id="credits_box.no_cv_access" />
            </Box>
          )}
        </Box>
      </Box>
    </Card>
  );
};

export default CreditsBox;